export default "__VITE_ASSET__H6Gyy$Nf__"